<template>
	<div ref="scrollContainer" id="page-panel" >
    <resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">
			<div class="title">
				<span>{{$t('left-menu.creditNotes')}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" @change="closeSelectedCreditNote" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
				 <el-button type="primary" @click="openCreditNoteEditor" size="small" :disabled="!$can('manage', 'CreditNotes')"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
			</div>
		</div>
    <el-row>
      <el-col :span="leftPanelSpan"  >
        <CreditNoteList @select="showCreditNote"></CreditNoteList>
			</el-col>
      <el-col :span="rightPanelSpan" v-if="showRightPanel" style="padding-left:10px;">
        <CreditNoteView @close="closeSelectedCreditNote" @edit="handleCreditNoteEdited" :selectedCreditNoteId="this.selectedCreditNoteId"></CreditNoteView>
			</el-col>
    </el-row>
		<CreditNoteEditor :visible="creditNoteEditorVisible" :creditNoteToEdit="creditNoteToEdit" @close="closeCreditNoteEditor"></CreditNoteEditor>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import CreditNoteEditor from '@/components/creditNote/credit-note-editor'
import CreditNoteList from './components/credit-note-list'
import CreditNoteView from './creditNote'

// import SalesOrdersView from './components/sales-order-view'

export default {
  name: 'CreditNotes',
  data() {
    return {
      leftPanelSpan : 24,
      pageWidth : 0,
	  pageHeight : 0,
      rightPanelSpan:0,
      showRightPanel:false,
      search : '',
			creditNoteToEdit : null,
			creditNoteEditorVisible: false,
			selectedCreditNoteIndex : null,
    };
  },components: {
    CreditNoteEditor,
    CreditNoteList,
		CreditNoteView
  },
  watch : {

  },
	methods: {
		handleCreditNoteEdited(creditNote){
			// console.log(creditNote)
		},
		closeCreditNoteEditor(){
			this.creditNoteEditorVisible = false;
			this.creditNoteToEdit = null;
		},
		openCreditNoteEditor(){
			this.creditNoteEditorVisible = true;
		},
		editInvoice(){
			// this.creditNoteToEdit = this.selectedInvoice;
			// this.openInvoiceEditor();
		},
		showCreditNote(index){
			this.selectedCreditNoteIndex = index;
			if(this.pageWidth<1054){
        this.leftPanelSpan=0;
        this.rightPanelSpan = 24;
      }else{
        this.leftPanelSpan=8;
        this.rightPanelSpan=16;
      }
			this.showRightPanel=true;
		},
		closeSelectedCreditNote(){
			this.rightPanelSpan=0;
      this.leftPanelSpan=24;
      this.showRightPanel=false;
		},
    close(){
			this.$router.go(-1);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
    ...mapActions('creditNotes',['changeMode']),
		...mapActions('statuses',['fetchCreditStatuses'])
	},
	computed: {
		selectedCreditNoteId(){
			if(this.selectedCreditNoteIndex!=null){
				return this.creditNotes[this.selectedCreditNoteIndex].id;
			}
			return null;
		},
		modeModel : {
			get(){ return this.mode},
			set(mode){this.changeMode(mode)}
		},
    ...mapState('creditNotes',['mode','creditNotes']),
	},
  mounted(){
    this.setPageWidth();
		this.fetchCreditStatuses();

  },
	created(){


	}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
